import OrderExportStockPage from './order-export-stock';

export default OrderExportStockPage;